<template>
    <modal name="task-modal" :adaptive="true" :height="'auto'" @before-open="onModalShow">
        <div class="loader" v-if="isLoading">
            <div class="lds-ripple">
                <div></div>
                <div></div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row" v-if="task.id">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="task-name">Nome tratta</label>
                                    <input readonly class="form-control" v-model="task.task_name" type="text" id="task-name"/>
                                    <small class="form-text text-muted">Un nome descrittivo</small>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="task-type">Tipo di task</label>
                                    <select class="form-control" v-model="task.task_type" id="task-type">
                                        <option value="" disabled>-- Seleziona tipologia --</option>
                                        <option v-for="(type, index) in types" :key="index" :value="type.value">
                                            {{ type.text }}
                                        </option>
                                    </select>
                                    <small class="form-text text-muted">Seleziona la tipologia di task</small>
                                </div>
                            </div>
                        </div> -->
                        <div class="row" v-for="(meta, index) in fmetas" :key="'meta-' + index">
                            <div class="col-md-12">
                                <!-- ATTENZIONE!!!! NASCONDO LA SELEZIONE DELLA SURVEY PER DEMO RUSSO -->
                                <!-- <div class="form-group" v-if="meta.meta_key === 'survey_guid'">
                                    <label :for="meta.meta_key">{{ meta._description }}</label>
                                    <select class="form-control" v-model="tmetas[meta.meta_key]" :id="meta.meta_key">
                                        <option value="" disabled>-- Seleziona survey --</option>
                                        <option v-for="(survey, index) in surveys.data" :key="index" :value="survey.id">
                                            {{ survey.survey_name }}
                                        </option>
                                    </select>
                                    <small class="form-text text-muted">{{ meta.description[0].meta_label }}</small>
                                </div> -->
                                <div class="form-group" v-if="meta.meta_key !== 'survey_guid'">
                                    <label :for="meta.meta_key">{{ meta._description }}</label>
                                    <input type="text" class="form-control text-uppercase" :id="meta.meta_key" v-model="tmetas[meta.meta_key]" />
                                    <small class="form-text text-muted">{{ meta.description[0].meta_label }}</small>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="task-expiration">Scadenza tratta</label>
                                    <input class="form-control" v-model="task.task_expiration" type="date" id="task-expiration"/>
                                    <small class="form-text text-muted">Quando scade la tratta</small>
                                </div>
                            </div>
                        </div> -->
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="task-desc">Descrizione (facoltativa)</label>
                                    <input class="form-control" v-model="task.task_description" type="text" id="task-desc"/>
                                </div>
                            </div>
                        </div>
                        <div v-if="$v.$error" class="alert alert-danger mb-0">
                            <!-- <span v-if="!$v.task.task_name.required">Un nome per il task è richiesto.<br></span> -->
                            <span v-if="!$v.task.task_expiration.required">Una scadenza per la tratta è richiesta.<br></span>
                            <span v-if="!$v.task.task_type.required">Seleziona il tipo tratta.<br></span>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button type="submit" class="btn btn-success" @click="saveTask">
                            <font-awesome-icon :icon="['far','save']"></font-awesome-icon>&nbsp;SALVA
                        </button>
                        <button type="button" class="btn btn-light" @click="closeModal">
                            <font-awesome-icon icon="times"></font-awesome-icon>&nbsp;ANNULLA
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
/* eslint-disable no-unused-vars */
const CURRENT_LANG = 'it'
// import tratte from '@/assets/data/tratte'

import {
    required
} from 'vuelidate/lib/validators'
import {
    MODULE_NAME as COMMONS_MODULE_NAME
} from '@/store/modules/commons.module'
import {
    MODULE_NAME as PROJECTS_MODULE_NAME
} from '@/store/modules/projects.module'
import {
    MODULE_NAME as SURVEYS_MODULE_NAME
} from '@/store/modules/surveys.module'
import {
    MODULE_NAME
} from '@/store/modules/tasks.module'
import {
    mapGetters
} from 'vuex'
import {
    GET_LIST,
    GET_SINGLE,
    CREATE,
    UPDATE,
    FETCH_METAS,
    FETCH_TYPES
} from '@/store/actions.type'

export default {
    name: 'task-modal',
    data () {
        return {
            isLoading: false
        }
    },
    props: {
        project: {
            type: Object,
            required: true
        },
        task: {
            type: Object
        }
    },
    validations: {
        task: {
            // task_name: {
            //     required
            // },
            task_expiration: {
                required
            },
            task_type: {
                required
            }
        }
    },
    computed: {
        ...mapGetters([
            'currentUser',
            'users'
        ]),
        ...mapGetters({
            types: `${COMMONS_MODULE_NAME}/getTypes`,
            metas: `${COMMONS_MODULE_NAME}/getMetas`,
            surveys: `${SURVEYS_MODULE_NAME}/getList`,
        }),
        fmetas () {
            var _SELF = this
            var _fmetas = this.metas.filter(function (m) {
                return m.task_type === _SELF.task.task_type
            })
            _fmetas = _fmetas.map((m) => {
                let desc = JSON.parse(m.description)
                m._description = desc[CURRENT_LANG]
                return m
            })
            return _fmetas
        },
        tmetas () {
            var _metas = []
            if (this.task.metas && this.task.metas.length) {
                this.task.metas.forEach(element => {
                    _metas[element.meta_key] = element.value
                })
            }
            return _metas
        }
    },
    methods: {
        closeModal () {
            this.$modal.hide('task-modal')
        },
        onModalShow () {
            this.$v.$reset()
            this.$store.dispatch(`${COMMONS_MODULE_NAME}/${FETCH_TYPES}`)
            this.$store.dispatch(`${COMMONS_MODULE_NAME}/${FETCH_METAS}`)
            this.$store.dispatch(`${SURVEYS_MODULE_NAME}/${GET_LIST}`, {
                query: {}
            })
        },
        saveTask () {
            this.$v.$touch()
            if (!this.$v.$invalid) {
                const ACTION = this.task.id ? UPDATE : CREATE
                this.task.task_parent = this.project.id
                this.task.task_user = this.project.project_company || this.currentUser.id
                this.task.metas = this.tmetas
                this.task.task_name = `${this.task.metas.route_from}-${this.task.metas.route_to}`
                if (this.task.metas.route_from === '' || this.task.metas.route_to === '') {
                    this.$swal('Oooops!', 'Aeroporto di partenza e arrivo sono obbligatori!', 'error')
                    return false
                }

                /** FISSO L'ID DELLA SURVEY */
                this.task.metas.survey_guid = 1
                /** DA RIMUOVERE !!!! */

                this.$store.dispatch(`${MODULE_NAME}/${ACTION}`, this.task).then((t) => {
                    if (t.status === 200) {
                        this.closeModal()
                        if (this.$route.params.id) {
                            this.$store.dispatch(`${PROJECTS_MODULE_NAME}/${GET_SINGLE}`, {
                                id: this.$route.params.id
                            })
                        } else {
                            this.$store.dispatch(`${PROJECTS_MODULE_NAME}/${GET_LIST}`, {
                                query: {}
                            })
                        }
                        this.$swal({
                            title: 'Ok!',
                            text: 'Tratta inserita correttamente.',
                            type: 'success'
                        })
                    } else {
                        this.$swal({
                            title: 'Oooops!',
                            text: 'Si è verificato un problema.',
                            type: 'error'
                        })
                    }
                })
            }
        }
    }
}
</script>
